import { Logo } from "@/components/pro-blocks/logo"
import { Separator } from "@/components/ui/separator"

export function Footer1() {
  return (
    <footer className="bg-background section-padding-y" role="contentinfo" aria-label="Site footer">
      <div className="container-padding-x container mx-auto flex flex-col gap-12 lg:gap-16">
        <div className="flex w-full flex-col items-center gap-12 text-center">
          <a
            href="#"
            aria-label="На главную"
            onClick={(e) => {
              e.preventDefault()
              window.scrollTo({ top: 0, behavior: "smooth" })
            }}
          >
            <Logo />
          </a>

          <nav className="flex flex-col items-center gap-6 text-sm md:flex-row md:gap-8" aria-label="Footer navigation">
            <a
              href="#"
              className="text-muted-foreground hover:text-foreground transition-colors"
              onClick={(e) => {
                e.preventDefault()
                window.scrollTo({ top: 0, behavior: "smooth" })
              }}
            >
              Главная
            </a>
            <a href="#features" className="text-muted-foreground hover:text-foreground transition-colors">
              Преимущества
            </a>
            <a href="#how-it-works" className="text-muted-foreground hover:text-foreground transition-colors">
              Как это работает
            </a>
            <a href="#pricing" className="text-muted-foreground hover:text-foreground transition-colors">
              Тарифы
            </a>
            <a href="#faq" className="text-muted-foreground hover:text-foreground transition-colors">
              FAQ
            </a>
          </nav>

          <div className="text-muted-foreground text-sm">
            Email:{" "}
            <a href="mailto:hello@feedbackiq.io" className="text-primary">
              hello@feedbackiq.io
            </a>
          </div>
        </div>

        <Separator role="presentation" />

        <div className="flex w-full flex-col-reverse items-center gap-12 text-sm lg:flex-row lg:justify-between lg:gap-6">
          <p className="text-muted-foreground text-center lg:text-left">© 2025 FeedbackIQ. Все права защищены.</p>

          <nav className="flex flex-col items-center gap-6 text-sm md:flex-row md:gap-8" aria-label="Legal links">
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
              Политика конфиденциальности
            </a>
            <a href="#" className="text-muted-foreground hover:text-foreground transition-colors">
              Условия использования
            </a>
          </nav>
        </div>
      </div>
    </footer>
  )
}
